import { Globe, ListChecks, TrendingUp } from 'lucide-react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

const DEFAULT_TABS = [
  { value: 'details', label: 'Details', icon: ListChecks },
  { value: 'trends', label: 'Trends', icon: TrendingUp },
  { value: 'world', label: 'World', icon: Globe },
];

export function AnalyticsTabBar({ tabs = DEFAULT_TABS, className, listClassName }) {
  return (
    <div className={cn('rounded-2xl border border-border bg-card/80 p-3 shadow-sm', className)}>
      <TabsList className={cn('grid h-auto w-full rounded-xl bg-secondary p-1.5', listClassName)} style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
        {tabs.map(({ value, label, icon: Icon }) => (
          <TabsTrigger
            key={value}
            value={value}
            className="gap-1.5 px-2 py-2.5 text-xs sm:gap-2 sm:text-sm"
            data-testid={`tab-${value}`}
          >
            {Icon && <Icon className="h-4 w-4" />}
            {label}
          </TabsTrigger>
        ))}
      </TabsList>
    </div>
  );
}

export { DEFAULT_TABS as ANALYTICS_TABS };
